// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import { Hidden } from "@material-ui/core";
import { FreelancerStepResume } from "./Parts/FreelancerStepResume";
import { getLanguage } from "../../../../../Helpers/LanguageHelper";
import { NavLink } from "react-router-dom";
interface IProps extends RouteComponentProps {}
interface IState {}
export class FreelancerSettingsResume extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }
  render() {
    return (
      <div>
        <div>
          <div className="padding-v-32 maxW-600">
          <Hidden smUp> 
              <NavLink to="/freelancer/settings">
                <i className="fas fa-arrow-left fa-lg margin-right-16"></i>
              </NavLink>
            </Hidden> 
          <h1 className="inline-block">{getLanguage(56, "My resume")}</h1>
            <FreelancerStepResume creatingUser={false}/>
          </div>
        </div>
      </div>
    );
  }
}
